module.exports = __webpack_public_path__ + "img/grey-webinars-1.2d5edea9.png";